import React from 'react';
import axios from "axios";
import { useRazorpay } from "react-razorpay";

const Razorpaybutton = ({
  totalPrice,
  currency = "INR",
  customerDetails = {},
  checkoutId,
  onSuccess,
  onError
}) => {

  const { error, isLoading, Razorpay } = useRazorpay();

  const handlePayment = async () => {
    try {
      if (!checkoutId) {
        alert("Checkout session missing. Refresh and try again.");
        return;
      }

      if (!totalPrice || totalPrice <= 0) {
        alert("Invalid amount. Reload page and try again.");
        return;
      }

      // 1️⃣ Create Razorpay Order from backend
      const { data } = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/api/checkout/${checkoutId}/create-order`,
        {},
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` }
        }
      );

      if (!data?.order?.id) {
        alert("Failed to initialize payment.");
        return;
      }

      const order = data.order;

      // 2️⃣ Setup Razorpay Checkout Options
      const options = {
        key: "rzp_live_RujWfB9EpmdFXa", // LIVE KEY
        order_id: order.id, // MUST BE FROM BACKEND
        amount: order.amount,
        currency: order.currency,
        name: "DRIPP TOUR",
        description: "Order Payment",
        image: "https://res.cloudinary.com/dmrlotfsv/image/upload/v1764055282/icon_confirm_mail_i78ri8.png",

        prefill: {
          name: customerDetails.name,
          email: customerDetails.email,
          contact: customerDetails.phone
        },

        notes: {
          checkoutId: checkoutId,
          email: customerDetails.email,
        },

        theme: {
          color: "#000000"
        },

        handler: function (response) {
          // 3️⃣ Send payment response back to Checkout.jsx
          if (onSuccess) {
            onSuccess({
              paymentId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
              signature: response.razorpay_signature,
              amount: totalPrice,
              currency,
              timestamp: new Date().toISOString()
            });
          }
        },

        modal: {
          ondismiss: () => console.log("Payment modal closed"),
          confirm_close: true,
        },

        retry: {
          enabled: true,
          max_count: 3,
        },

        timeout: 300000, // 5 MINUTES (previously 300 = 0.3 sec)
      };

      // 4️⃣ Open Razorpay Modal
      const rzp = new Razorpay(options);

      rzp.on("payment.failed", (response) => {
        console.error("Payment Failed:", response.error);

        if (onError) onError(response.error);
        else alert(response.error.description || "Payment failed. Try again.");
      });

      rzp.open();

    } catch (err) {
      console.error("Error initializing payment", err);
      onError?.(err);
      alert("Something went wrong while processing payment.");
    }
  };

  if (isLoading) {
    return (
      <button
        disabled
        className="w-full bg-gray-400 text-white py-3 px-4 rounded-md cursor-not-allowed flex items-center justify-center"
      >
        Loading Payment Gateway...
      </button>
    );
  }

  if (error) {
    return (
      <div className="text-red-600 text-center p-4 bg-red-50 rounded-md">
        ⚠️ Payment Gateway Error — Reload Page
      </div>
    );
  }

  return (
    <button
      onClick={handlePayment}
      disabled={!checkoutId || totalPrice <= 0}
      className="w-full bg-black text-white py-3 px-4 rounded-md hover:bg-gray-800 transition-colors font-medium"
    >
      Pay ₹{totalPrice.toFixed(2)}
    </button>
  );
};

export default Razorpaybutton;
